import { ETelemetryType } from '../types.mjs';

class ConsoleTransport {
    send(sample) {
        const messageType = sample.type === ETelemetryType.COUNTER ? 'TELEMETRY.increment:' : 'TELEMETRY.timer:';
        // eslint-disable-next-line no-console
        console.log(messageType, sample.key, sample.value);
    }
}

export { ConsoleTransport };
//# sourceMappingURL=console.mjs.map
